import { RouteRecordRaw } from 'vue-router'

export const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		redirect: '/lekar'
	},
	{
		path: '/lekar',
		name: 'App',
		redirect: '/lekar/prehlad',
		component: () => import('@/plugins/app/layout/default/default.layout.vue'),
		children: [
			{
				path: 'prehlad',
				name: 'Dashboard',
				component: () => import('@/plugins/app@lz/dashboard/dashboard/dashboard.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'vysledky',
				name: 'Results',
				component: () => import('@/plugins/app@lz/result/list/list.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'ziadanky',
				name: 'Requests',
				component: () => import('@/plugins/app@lz/request/list/list.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'odberove-supravy',
				name: 'Materials Orders',
				component: () => import('@/plugins/app@lz/material-order/list/list.vue'),
				meta: { requiresAuth: true }
			},

			{
				path: 'pacienti',
				name: 'Patients',
				component: () => import('@/plugins/app@lz/patient/list/list.vue'),
				meta: { requiresAuth: true }
			},

			{
				path: 'pacienti/detail/:patientId',
				name: 'Patients - Detail',
				component: () => import('@/plugins/app@lz/patient/detail/detail.vue'),
				meta: { requiresAuth: true }
			},

			{
				path: 'extra-ponuky',
				name: 'Benefits',
				component: () => import('@/plugins/app/views/benefits/benefits.vue'),
				meta: { requiresAuth: true }
			},

			{
				path: 'profil',
				name: 'Profile',
				component: () => import('@/plugins/app/layout/profile/profile.layout.vue'),
				children: [
					{
						path: '',
						name: 'Profile - Personal Info',
						component: () =>
							import('@/plugins/app@lz/profile/personal-info/personal-info.vue'),
						meta: { requiresAuth: true }
					},
					{
						path: 'login-info',
						name: 'Profile - Login Info',
						component: () =>
							import('@/plugins/app@lz/profile/login-info/login-info.vue'),
						meta: { requiresAuth: true }
					},
					{
						path: 'contact-form',
						name: 'Profile - Contact Form',
						component: () =>
							import('@/plugins/app@lz/profile/contact-form/contact-form.vue'),
						meta: { requiresAuth: true }
					},
					{
						path: 'notifications-info',
						name: 'Profile - Notifications Info',
						component: () =>
							import(
								'@/plugins/app@lz/profile/notifications-info/notifications-info.vue'
							),
						meta: { requiresAuth: true }
					},
					{
						path: 'service-offers',
						name: 'Profile - Service Offers',
						component: () =>
							import('@/plugins/app@lz/profile/service-offers/service-offers.vue'),
						meta: { requiresAuth: true }
					},
					{
						path: 'templates',
						name: 'Profile - Templates',
						component: () => import('@/plugins/app@lz/profile/templates/templates.vue'),
						meta: { requiresAuth: true }
					},
					{
						path: 'manual',
						name: 'Profile - Manual',
						component: () => import('@/plugins/app@lz/profile/manual/manual.vue'),
						meta: { requiresAuth: true }
					},
					{
						path: 'documents',
						name: 'Profile - Documents',
						component: () => import('@/plugins/app@lz/profile/documents/documents.vue'),
						meta: { requiresAuth: true }
					},
					{
						path: 'platby',
						name: 'Profile - Payments',
						component: () => import('@/plugins/app@lz/profile/payments/payments.vue'),
						meta: { requiresAuth: true }
					}
				]
			}
		]
	},

	{
		path: '/prihlasenie',
		component: () => import('@/plugins/app/layout/auth/auth.layout.vue'),
		children: [
			{
				path: '',
				name: 'Login',
				component: () => import('@/plugins/app@lz/auth/login/login.vue'),
				meta: { requiresAuth: false }
			},
			{
				path: 'grid-karta',
				name: 'Login - Grid Card',
				component: () => import('@/plugins/app@lz/auth/login/grid-card.vue'),
				meta: { requiresAuth: false }
			},
			{
				path: 'sms-kod',
				name: 'Login - SMS Code',
				component: () => import('@/plugins/app@lz/auth/login/sms-code.vue'),
				meta: { requiresAuth: false }
			},
			{
				path: 'podmienky',
				name: 'Login - Podmienky',
				component: () => import('@/plugins/app@lz/auth/login/terms.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'vyber-pristupu',
				name: 'Login - Select Department',
				component: () => import('@/plugins/lib@auth/views/select-access/select-access.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'zabudnute-heslo',
				name: 'Forgot Password',
				component: () =>
					import('@/plugins/app@lz/auth/forgot-password/forgot-password.vue'),
				meta: { requiresAuth: false }
			},
			{
				path: 'potvrdenie-ziadosti-heslo',
				name: 'Forgot Password Confirmation',
				component: () =>
					import(
						'@/plugins/app@lz/auth/forgot-password/forgot-password-confirmation.vue'
					),
				meta: { requiresAuth: false }
			},

			{
				path: 'jwt',
				name: 'Login wit JWT token',
				component: () => import('@/plugins/app@lz/auth/login/jwt-login.vue'),
				meta: { requiresAuth: null }
			}
		]
	},

	{
		path: '/lekar/ziadanky/jednostranna-ziadanka',
		name: 'Single Page Request',
		component: () => import('@/plugins/app@lz/request/single-page-request/single-page-request.vue'),
		meta: { requiresAuth: true }
	}
]
